module.exports = __webpack_public_path__ + "static/media/blossom.5e0d1a2e.jpg";